require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-kasim-material-engineer-software-developer-code-fellows-graduate.json") })
        }
      }, "path---blog-meet-kasim-material-engineer-software-developer-code-fellows-graduate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-kasim-material-engineer-software-developer-code-fellows-graduate!./.cache/json/blog-meet-kasim-material-engineer-software-developer-code-fellows-graduate.json
// module id = 989
// module chunks = 231608221292675